export const version = '1.4.1';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@supabase/postgrest-js/dist/module/version.js
// module id = null
// module chunks = 